export default {
  RESET: 'MapToolPlayerReset',
  NEXT_FRAME: 'MapToolPlayerNextFrame',
  PLAY_END: 'MapToolPlayerPlayEnd'
}



// WEBPACK FOOTER //
// ./src/components/MapTools/PlayerCtrlBar/eventKeyMap.js